import { useSyncExternalStore } from 'react';
import { player } from '../../state/player';

/**
 * Shared sound state for all feed videos. Feed videos start muted (browser
 * autoplay policy); unmuting a video pauses the music player and starting
 * music mutes the feed, so two audio sources never play at once.
 */
let state = { muted: true, volume: 1, unlockedOnce: false };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const feedAudio = {
  get: () => state,
  setMuted(muted: boolean) {
    state = { ...state, muted, unlockedOnce: state.unlockedOnce || !muted };
    if (!muted && player.state.playing) player.pause();
    emit();
  },
  setVolume(volume: number) {
    state = { ...state, volume, muted: volume === 0 ? true : state.muted };
    emit();
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

window.addEventListener('bb:music-play', () => {
  if (!state.muted) feedAudio.setMuted(true);
});

export function useFeedAudio() {
  return useSyncExternalStore(feedAudio.subscribe, feedAudio.get);
}
